import {ParentComponentProvider} from "../../../context/ParentComponentContext";
import C027Quote from "../../content/C027Quote/C027Quote";
import {
    CmCollection,
    Cmhtml,
    CmPicture,
    CmVideo,
    FormEditor,
    SosAmountIncreaseForm,
    SosDonationCard,
    SosDonationProgress,
    SosOrderForm
} from "../../../../packages/graphql-layer/src";
import CCOArticle from "../../fundamentals/CCOArticle";
import React, {useEffect, useState} from "react";
import {
    SosTextfragmentFragment
} from "../../../../packages/graphql-layer/src/queries/fragments/__generated__/SOSTextfragment.fragment";
import C036SearchAction from "../../content/C036SearchField/C036SearchAction";
import {useQuery} from "@apollo/client";
import {
    GetCollectionByIdDocument
} from "../../../../packages/graphql-layer/src/queries/__generated__/GetCollectionById";
import {GetCmPictureByIdDocument} from "../../../../packages/graphql-layer/src/queries/__generated__/GetCMPictureById";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import CCOComment from "../../fundamentals/CCOComment";
import C077LobsterRequestSimpleAction from "../../content/C077LobsterRequest/C077LobsterRequestSimpleAction";
import {getCypressDataProperty} from "../../../utility/componentUtil";
import C029TextFragment from "../../content/C029TextFragment/C029TextFragment";
import CollectionViewType from "./CollectionViewType";
import {hideForBreakpoint, useBreakpoints} from "../../../utility/layoutUtils";
import dynamic from "next/dynamic";
import { Box } from "@mui/material";
import C082CenteredStageTeaser from "../../content/C082CenteredStageTeaser/C082CenteredStageTeaser";
import C014StageTeaser from "../../content/C014StageCarousel/C014StageTeaser";


interface Props {
    CAEGlobalSettings: any,
    csrfToken: string,
    isOverlayPreview?: boolean,
    isPreview?: boolean,
    item: any,
    pageSettings?: any,
    placeholderContent?: any,
    renderPictureSizes?: boolean,
    richTextItemId?: string,
    credentials?: any
}

const C085ProductTeaserContainer = dynamic(() => import('../../content/C085ProductTeaser/C085ProductTeaserContainer'));
const C003Download = dynamic(() => import('../../content/C003Download/C003Download'));
const C041Video = dynamic(() => import('../../content/C041Video/C041Video'));
const C040Picture = dynamic(() => import('../../content/C040Picture/C040Picture'));
const C067HtmlFragment = dynamic(() => import('../../content/C067HtmlFragment/C067HtmlFragment'));
const CCODonationInitializer = dynamic(() => import('../../fundamentals/CCODonationInitializer'), {ssr: false});
const C023NewsletterTeaser = dynamic(() => import('../../content/C023NewsletterTeaser/C023NewsletterTeaser'), {ssr: false});
const C018StandardTeaser = dynamic(() => import('../../content/C018StandardTeaser/C018StandardTeaser'), {ssr: false});
const C028Infobox = dynamic(() => import('../../content/C028Infobox/C028Infobox'), {ssr: false});
const C022ContactTeaser = dynamic(() => import('../../content/C022ContactTeaser/C022ContactTeaser'), {ssr: false});
const C016GlobalFilter = dynamic(() => import('../../content/C016GlobalFilter/C016GlobalFilter'), {ssr: false});
const C031JobTeaserPlaceholder = dynamic(() => import('../../content/C031JobTeaserPlaceholder/C031JobTeaserPlaceholder'),  {ssr: false});
const C036PublicationSearchAction = dynamic(() => import('../../content/C036SearchField/C036PublicationSearchAction'), {ssr: false});
const C024CTATeaser = dynamic(() => import('../../content/C024CTATeaser/C024CTATeaser'), {ssr: false});
const C062OverlayForm = dynamic(() => import('../../content/C062OverlayForm/C062OverlayForm'), {ssr: false});
const C060OverlayTeaser = dynamic(() => import('../../content/C060OverlayTeaser/C060OverlayTeaser'), {ssr: false});
const C061OverlayContact = dynamic(() => import('../../content/C061OverlayContact/C061OverlayContact'), {ssr: false});
const C080DonationProgress = dynamic(() => import('../../content/C080DonationProgress/C080DonationProgress'), {ssr: false});
const C081DonationTool = dynamic(() => import('../../content/C081DonationTool/C081DonationTool'), {ssr: false});
const F005OrderForm = dynamic(() => import('../../forms/F005OrderForm/F005OrderForm'), {ssr: false});
const C056QueryList = dynamic(() => import('../../content/C056QueryList/C056QueryList'),  {ssr: false});
const C046FormEditor = dynamic(() => import('../../content/C046FormEditor/C046FormEditor'),  {ssr: false});
const F006AmountIncreaseForm = dynamic(() => import('../../forms/F006AmountIncreaseForm/F006AmountIncreaseForm'), {ssr: false});

function PlacementItem(props: Props) {

    const [richTextItem, setRichTextItem] = useState(null);
    const currentBreakpoint = useBreakpoints();

    useEffect(() => {
    }, [richTextItem]);

    const queryDocument = props.item.type === "CMPicture" ? GetCmPictureByIdDocument : GetCollectionByIdDocument
    useQuery(queryDocument, {
        variables: {contentId: props.richTextItemId},
        onError: (err) => {
            console.log("Can't load collection:");
            console.log(err);
        },
        onCompleted: (data) => {
            if (!data.content.content) {
                console.error("Can't load collection:")
                return
            }
            setRichTextItem(data.content.content)
        },
        fetchPolicy: 'network-only',
        skip: props.richTextItemId === null || props.richTextItemId === undefined,
    });

    const item = richTextItem ?? props.item

    if (hideForBreakpoint(currentBreakpoint, item.responsiveSettings)) {
        return null
    }

    switch (item.type) {
        case 'CMCollection': {
            return <CollectionViewType item={item}
                                       CAEGlobalSettings={props.CAEGlobalSettings}
                                       richTextItemId={props.richTextItemId}/>
        }
        case "FormEditor": {
            const form = item as FormEditor
            return <CCOComment text='form.C046FormEditor'><C046FormEditor drymode={false} formEditor={form} id={item.id} csrfToken={props.csrfToken}
                                                                          pageSettings={props.pageSettings} fcSiteKey={props.credentials?.friendlyCaptchaId}/></CCOComment>
        }
        case "SOSTextfragment": {
            const sosTextFragmentItem = item as SosTextfragmentFragment
            switch (item.viewtype) {
                case "c027_quote":
                case "quote": {
                    return <CCOComment text='textfragment.C027Quote'><ParentComponentProvider id={item.id}><C027Quote sosTextFragment={sosTextFragmentItem}/></ParentComponentProvider></CCOComment>
                }
                case "c028_infobox":
                case "infobox": {
                    return <CCOComment text='textfragment.C028Infobox'><ParentComponentProvider id={item.id}><C028Infobox sosTextFragment={sosTextFragmentItem}/></ParentComponentProvider></CCOComment>
                }
                default: {
                    return <CCOComment text='textfragment.C029TextFragment'><ParentComponentProvider id={item.id}><C029TextFragment
                        sosTextFragment={item}/></ParentComponentProvider></CCOComment>
                }
            }
        }
        case "CMHTML": {
            const cmHtml = item as Cmhtml
            return <CCOComment text='html.C067HtmlFragment'><C067HtmlFragment cmHtml={cmHtml} isPreview={props.isPreview}/></CCOComment>
        }
        case "CMVideo": {
            const video = item as CmVideo
            return <CCOComment text='video.C041Video'><C041Video layoutSettings={item.layoutSettings} video={video}/></CCOComment>
        }
        case "CMDownload": {
            return <CCOComment text='cmCollection.C003Download'><C003Download cmCollection={{items: [item]} as CmCollection}/></CCOComment>
        }
        case "CMPicture": {
            const picture = item as CmPicture
            if (!picture || !picture.id) return null

            return <CCOComment text='picture.C040Picture'><C040Picture picture={picture} isPreview={props.renderPictureSizes}
                                                                       isRichText={props.richTextItemId !== undefined}
                                                                       clazz={props.item.clazz}/></CCOComment>
        }
        case "SOSDonationCard": {
            const card = item as SosDonationCard;
            const supportedViewtypes = ["modularDonationCard", "modularDonationCardSticky", "c083_modular_donation_card", "c084_modular_donation_card_sticky"];

            if (supportedViewtypes.includes(item.viewtype)) {
                return <CCODonationInitializer
                    key={card.id}
                    item={card}
                    csrfToken={props.csrfToken}
                />
            }
            return null;
        }
        case "SOSDonationForm": {
            const supportedViewtypes = ["f007_modular_donation_form", "modularDonationForm"];
            if (supportedViewtypes.includes(item.viewtype)) {
                return (
                    <Box sx={{ minHeight: '2000px', width: '100%' }}>
                        <CCODonationInitializer
                        item={item}
                        csrfToken={props.csrfToken}
                        />
                    </Box>
                );
            }
            return null;
        }
        case "SOSAmountIncreaseForm": {
            const sosAmountIncreaseForm = item as SosAmountIncreaseForm;
            return <CCOComment text='item.F006AmountIncreaseForm'>
                <React.Fragment key="amountIncreaseItem">
                    <F006AmountIncreaseForm
                        id={item.id}
                        sosAmountIncreaseForm={sosAmountIncreaseForm}
                        csrfToken={props.csrfToken}
                        donationContext={item.donationContext.donation_context as any}
                    />
                </React.Fragment>
            </CCOComment>
        }

        case "SOSDonationProgress": {
            const donationProgress = item as SosDonationProgress;
            return <CCOComment text='item.C080DonationProgress'>
                <React.Fragment key="donationProgress">
                    <C080DonationProgress
                        actionId={""}
                        id={donationProgress.id}
                        item={donationProgress}
                        csrfToken={props.csrfToken}
                    />
                </React.Fragment>
            </CCOComment>
        }
        case "SOSDonationTool": {
            const donationTool = item as any;
            return <CCOComment text='item.C081DonationTool'>
                <React.Fragment key="donationTool">
                    <C081DonationTool
                        id={donationTool.id}
                        item={donationTool}
                        csrfToken={props.csrfToken}
                    />
                </React.Fragment>
            </CCOComment>
        }
        case "SOSOrderForm": {
            const orderForm = item as SosOrderForm;
            return <CCOComment text='item.F005OrderForm'>
                <React.Fragment key="orderFormItem">
                    <F005OrderForm
                        id={item.id}
                        orderForm={orderForm}
                        csrfToken={props.csrfToken}
                    />
                </React.Fragment>
            </CCOComment>
        }
        case "SOSTeaser": {
            switch (item.viewtype) {
                case "c023_newsletter_teaser":
                case "asAboTeaser": {
                    return <CCOComment text='teaser.C023NewsletterTeaser'><ParentComponentProvider id={item.id}><C023NewsletterTeaser sosTeaser={item}/></ParentComponentProvider></CCOComment>
                }
                case "c024_cta_teaser":
                case "asCTATeaser": {
                    return <CCOComment text='teaser.C024CTATeaser'><ParentComponentProvider id={item.id}><C024CTATeaser sosTeaser={item} layoutSettings={item.layoutSettings}/></ParentComponentProvider></CCOComment>
                }
                case "c082_centered_stage_teaser": {
                    return <CCOComment text='teaser.C082CenteredStageTeaser'><ParentComponentProvider id={item.id}><C082CenteredStageTeaser item={item}/></ParentComponentProvider></CCOComment>
                }
                default: {
                    return <>
                        <CCOComment text='teaser.C014StageTeaser'><ParentComponentProvider id={item.id}><C014StageTeaser item={item}/></ParentComponentProvider></CCOComment>
                    </>
                }
            }

        }
        case "SOSDonationProduct": {
            let items = [item];
            return <CCOComment text='item.C085ProductTeaserContainer'><C085ProductTeaserContainer items={items} key={item.id} /></CCOComment>
        }
        case "CMQueryList": {
            return <CCOComment text='item.C056QueryList'><C056QueryList queryList={item} viewType={item.viewtype}/></CCOComment>
        }
        case "SOSContact": {
            return <CCOComment text='item.C022ContactTeaser'><C022ContactTeaser contactTeaser={item}/></CCOComment>
        }
        case "CMArticle": {
            return <CCOComment text='item.CCOArticle'><ParentComponentProvider id={item.id}><CCOArticle item={item} layoutSettings={item.layoutSettings}/></ParentComponentProvider></CCOComment>
        }
        case "CMPlaceholder": {
            switch (item.viewtype) {
                case "c016_global_filter":
                case "asSpecialTopicCrossLinkTeaser": {
                    return <CCOComment text='item.C016GlobalFilter'><C016GlobalFilter specialTopicCategory={props!.placeholderContent}/></CCOComment>
                }
                case "c031_job_teaser_placeholder":
                case "jobTeaser": {
                    return <CCOComment text='item.C031JobTeaserPlaceholder'><C031JobTeaserPlaceholder placeholder={props!.item}/></CCOComment>
                }
                default: {
                    return <CCOComment text='item.C018StandardTeaser'><C018StandardTeaser dataCypress={getCypressDataProperty(item) + 'StandardTeaser'} cmTeaser={item} displayDate={false}/></CCOComment>
                }
            }
        }
        case "SOSOverlay": {
            switch (item.viewtype) {
                case "c060_overlay_teaser":
                case "teaserOverlay": {
                    return <CCOComment text='item.C060OverlayTeaser'>
                        <C060OverlayTeaser breakpoints={item.autoShowOverlayInBreakpoints}
                                           details={item.details!.textAsTree as RichTextElement}
                                           id={item.id}
                                           isPreview={props.isOverlayPreview}
                                           picture={item.picture}
                                           title={item.title}
                                           linksTarget={item.linkTargets}
                                           itemId={item.id}/>
                    </CCOComment>
                }
                case "c061_overlay_contact":
                case "contactOverlay": {
                    return item.details ? <CCOComment text='item.C061OverlayContact'>
                        <C061OverlayContact breakpoints={item.autoShowOverlayInBreakpoints}
                                            id={item.id}
                                            details={item.details!.textAsTree as RichTextElement}
                                            isPreview={props.isOverlayPreview}
                                            picture={item.picture}
                                            subtitle={item.subtitle}
                                            targets={item.linkTargets}
                                            title={item.title}
                        /></CCOComment> : null
                }
                case "c062_overlay_form":
                case "formOverlay": {
                    return <CCOComment text='item.C062OverlayForm'>
                        <C062OverlayForm breakpoints={item.autoShowOverlayInBreakpoints}
                                         id={item.id}
                                         formData={item.items[0]}
                                         isPreview={props.isOverlayPreview}
                                         pageSettings={props.pageSettings}
                                         picture={item.picture}
                                         subtitle={item.subtitle}
                                         title={item.title}
                                         token={props.csrfToken}
                                         fcSiteKey={props.credentials?.friendlyCaptchaId} />
                    </CCOComment>
                }
                default: {
                    return <CCOComment text='item.C018StandardTeaser'><C018StandardTeaser dataCypress={getCypressDataProperty(item) + 'StandardTeaser'} cmTeaser={item} displayDate={false}/></CCOComment>
                }
            }
        }
        default: {
            switch (item.viewtype) {
                case "Standard": {
                    // News Teaser
                    return <CCOComment text='item.C018StandardTeaser'><C018StandardTeaser dataCypress={getCypressDataProperty(item) + 'StandardTeaser'} cmTeaser={item} displayDate={true}/></CCOComment>
                }
                case "search-all": {
                    return <CCOComment text='item.C036SearchAction'><C036SearchAction/></CCOComment>
                }
                case "search-publication": {
                    return <CCOComment text='item.C036PublicationSearchAction'><C036PublicationSearchAction/></CCOComment>
                }
                case "lobster-request-simple": {
                    return <CCOComment text='item.C077LobsterRequestSimpleAction'><C077LobsterRequestSimpleAction cmAction={item} csrfToken={props.csrfToken} /></CCOComment>
                }
                default: {
                    return <CCOComment text='item.C018StandardTeaser'><C018StandardTeaser dataCypress={getCypressDataProperty(item) + 'StandardTeaser'} cmTeaser={item} displayDate={false}/></CCOComment>
                }
            }
        }
    }
}

export default PlacementItem